<!-- Header Section -->
<div class="p-4 lg:p-6 space-y-4">
  <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">
    <p class="text-0d5bab font-bold text-[13px] sm:text-sm lg:text-base xl:text-lg capitalize mb-2 md:mb-0">
      {{ selectedYear }} Financial Balance Sheet
    </p>

    <div class="flex flex-wrap items-center justify-start gap-2">
      <!-- Firm Dropdown -->
      <select [(ngModel)]="selectedFirmId" (change)="onFilterChange()"
        class="cursor-pointer bg-white border border-d9d9d9 rounded-md ps-1 2xl:ps-2 pe-7 py-2 text-[13px] text-383838 focus:outline-none">
        <option value="">All Firms</option>
        <option *ngFor="let firm of firms" [value]="firm.id">
          {{ firm.name }}
        </option>
      </select>

      <!-- Financial Year Select -->
      <div class="flex items-center gap-2">
        <p class="text-0d5bab text-xs lg:text-sm capitalize font-bold whitespace-nowrap">Select Financial Year :</p>
        <select [(ngModel)]="selectedYear"
          class="bg-white border border-acb1c6 rounded-md ps-1 2xl:ps-2 pe-7 py-2 text-[13px] text-383838 focus:outline-none">
          <option value="">Select Year</option>
          <option *ngFor="let year of years" [value]="year">{{ year }}</option>
        </select>
      </div>

      <!-- Go Button -->
      <button (click)="loadBalanceSheet()"
        class="w-max px-4 py-2 cursor-pointer rounded-md border-0d5bab bg-0d5bab text-white text-[13px] lg:text-[15px] font-medium hover:shadow-md transition">
        Go
      </button>

      <!-- Export Button -->
      <button (click)="exportToExcel()"
        class="cursor-pointer capitalize rounded-md border border-898989 bg-white text-898989 text-[13px] lg:text-[15px] font-medium px-2 lg:px-4 py-2 text-center hover:shadow-sm transition">
        Export
      </button>

      <!-- Print Button -->
      <button (click)="printBalanceSheet()"
        class="cursor-pointer capitalize rounded-md border border-0d5bab bg-e7eefb text-0d5bab text-[13px] lg:text-[15px] font-medium px-2 lg:px-4 py-2 text-center hover:shadow-sm transition">
        Print
      </button>
    </div>
  </div>

  <!-- Balance Sheet Content -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 pt-4">
    <!-- Liabilities -->
    <div class="col-span-1">
      <div class="h-full flex flex-col border border-ededed rounded-xl overflow-hidden">
        <p class="p-2 lg:px-3 text-center text-base lg:text-lg font-medium bg-0d5bab text-white capitalize">
          Liabilities
        </p>
        <div class="w-full sm:flex items-start flex-1 min-h-[300px]">
          <!-- Col 1 -->
          <div class="p-2 lg:p-3 space-y-2 w-full sm:w-1/2 sm:border-r border-ededed h-full">
            <div *ngFor="let item of liabilitiesCol1"
              class="flex items-center justify-between gap-2 border-b border-gray-50 pb-1">
              <p class="text-444 font-normal text-[13px] lg:text-sm xl:text-[15px] capitalize">{{ item.name }}</p>
              <p class="text-444 font-bold text-[13px] lg:text-sm xl:text-[15px]">{{ formatAmount(item.amount) }}</p>
            </div>
            <div *ngIf="liabilitiesCol1.length === 0" class="text-gray-400 text-xs italic text-center py-4">No records
            </div>
          </div>
          <!-- Col 2 -->
          <div class="p-2 lg:p-3 space-y-2 w-full sm:w-1/2">
            <div *ngFor="let item of liabilitiesCol2"
              class="flex items-center justify-between gap-2 border-b border-gray-50 pb-1">
              <p class="text-444 font-normal text-[13px] lg:text-sm xl:text-[15px] capitalize">{{ item.name }}</p>
              <p class="text-444 font-bold text-[13px] lg:text-sm xl:text-[15px]">{{ formatAmount(item.amount) }}</p>
            </div>
          </div>
        </div>
        <div class="p-2 lg:px-3 bg-ebf1ff flex items-center justify-between gap-2" *ngIf="diffLiabilities !== 0">
          <p class="text-center text-base lg:text-[17px] font-medium text-666 capitalize">
            Diff. in Balance
          </p>
          <p class="text-center text-base lg:text-[17px] font-medium text-666 capitalize">
            {{ formatAmount(diffLiabilities) }}
          </p>
        </div>
        <div class="p-2 lg:px-3 bg-0d5bab flex items-center justify-between gap-2">
          <p class="text-center text-base lg:text-[17px] font-medium text-white capitalize">
            Total
          </p>
          <p class="text-center text-base lg:text-[17px] font-medium text-white capitalize">
            {{ formatAmount(grandTotal) }}
          </p>
        </div>
      </div>
    </div>

    <!-- Assets -->
    <div class="col-span-1">
      <div class="h-full flex flex-col border border-ededed rounded-xl overflow-hidden">
        <p class="p-2 lg:px-3 text-center text-base lg:text-lg font-medium bg-6eb67b text-white capitalize">
          Assets
        </p>
        <div class="w-full sm:flex items-start flex-1 min-h-[300px]">
          <!-- Col 1 -->
          <div class="p-2 lg:p-3 space-y-2 w-full sm:w-1/2 sm:border-r border-ededed h-full">
            <div *ngFor="let item of assetsCol1"
              class="flex items-center justify-between gap-2 border-b border-gray-50 pb-1">
              <p class="text-444 font-normal text-[13px] lg:text-sm xl:text-[15px] capitalize">{{ item.name }}</p>
              <p class="text-444 font-bold text-[13px] lg:text-sm xl:text-[15px]">{{ formatAmount(item.amount) }}</p>
            </div>
            <div *ngIf="assetsCol1.length === 0" class="text-gray-400 text-xs italic text-center py-4">No records</div>
          </div>
          <!-- Col 2 -->
          <div class="p-2 lg:p-3 space-y-2 w-full sm:w-1/2">
            <div *ngFor="let item of assetsCol2"
              class="flex items-center justify-between gap-2 border-b border-gray-50 pb-1">
              <p class="text-444 font-normal text-[13px] lg:text-sm xl:text-[15px] capitalize">{{ item.name }}</p>
              <p class="text-444 font-bold text-[13px] lg:text-sm xl:text-[15px]">{{ formatAmount(item.amount) }}</p>
            </div>
          </div>
        </div>
        <div class="p-2 lg:px-3 bg-ecffeb flex items-center justify-between gap-2" *ngIf="diffAssets !== 0">
          <p class="text-center text-base lg:text-[17px] font-medium text-666 capitalize">
            Diff. in Balance
          </p>
          <p class="text-center text-base lg:text-[17px] font-medium text-666 capitalize">
            {{ formatAmount(diffAssets) }}
          </p>
        </div>
        <div class="p-2 lg:px-3 bg-6eb67b flex items-center justify-between gap-2">
          <p class="text-center text-base lg:text-[17px] font-medium text-white capitalize">
            Total
          </p>
          <p class="text-center text-base lg:text-[17px] font-medium text-white capitalize">
            {{ formatAmount(grandTotal) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>